<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list"></i>
          <strong>
            {{ title }}
            <b-spinner v-if="loading" class="float-right" small></b-spinner>
          </strong>
        </div>
        <div>
          <v-server-table
            :url="url"
            :columns="columns"
            :options="options"
            :theme="theme"
            ref="table"
            id="dataTable"
          >
            <template slot="afterFilter">
              <tr class="VueTables__no-results">
                <b-button @click="resetFilters">Limpiar filtro</b-button>
              </tr>

              <tr v-if="loading" class="VueTables__no-results">
                <b-spinner
                  v-if="loading"
                  variant="primary"
                  class="ml-2 mt-1"
                  small
                  label="Small Spinner"
                ></b-spinner>
              </tr>
            </template>

            <template slot="status" slot-scope="props">
              <b-badge pill :variant="getBadge(props.row.status)">
                {{ props.row.status }}
              </b-badge>
            </template>

            <div class="text-center" slot="actions" slot-scope="props">
              <a
                target="_blank"
                href="#"
                @click.prevent="openReport(props.row.id)"
                class="fa fa-lg fa-search text-primary"
              ></a
              >&nbsp;
              <!-- <a
                target="_blank"
                v-if="props.row.status != 'Cerrado'"
                href="#"
                @click.prevent="editProcess(props.row)"
                class="fa fa-lg fa-edit text-primary"
              ></a
              >&nbsp; -->
              <a
                target="_blank"
                v-if="props.row.status != 'Cerrado'"
                href="#"
                @click.prevent="editProcess2(props.row)"
                class="fa fa-lg fa-edit text-primary"
              ></a
              >&nbsp;
            </div>

            <!--            <div slot="beforeLimit">-->
            <!--              <download-excel-->
            <!--                class="btn"-->
            <!--                :fetch="fetchData"-->
            <!--                :fields="json_fields2"-->
            <!--                worksheet="Stock"-->
            <!--                :name="name"-->
            <!--                :before-generate="startDownload"-->
            <!--                :before-finish="finishDownload">-->
            <!--                <b-link>Descargar</b-link>-->
            <!--              </download-excel>-->

            <!--            </div>-->
          </v-server-table>
        </div>
      </b-card>
      <b-modal
        id="modal-process-report"
        ref="reportModal"
        centered
        size="lg"
        title="Detalle de proceso"
        @ok="
          report = null;
          data = null;
        "
        @hide="
          report = null;
          data = null;
        "
        ok-only
      >
        <div class="text-center">
          <b-spinner v-if="loading" label="Spinning"></b-spinner>
        </div>
        <component :is="report" :process="process_id"></component>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./ProcessReport";
import Report2 from "./ProcessReport2";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "ProcessList",
  components: {
    ServerTable,
    Report,
    Report2
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  data() {
    return {
      title: "Listado de procesos",
      loading: false,
      report: "report",
      process_id: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields2: {
        Exportadora: "client_customer_name"
      },
      columns: ["date", "number", "process_type", "status", "actions"],
      report_data: null,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function(resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }
          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        filterByColumn: true,
        filterable: ["date", "number", "process_type", "status"],
        listColumns: {
          status: [
            { id: "Abierto", text: "Abierto" },
            { id: "Cerrado", text: "Cerrado" }
          ]
        },
        headings: {
          date: "Fecha",
          number: "Numero",
          process_type: "Tipo",
          actions: " "
        },
        debounce: 800,
        columnsDropdown: true,
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    name() {
      return "Stock " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    url() {
      const c = this.$route.params.process_type;
      return "/bagno/process/?process_type=" + (c ? c : "");
    }
  },
  methods: {
    editProcess(a) {
      this.$router.push({ name: "bagno-procesos-ingreso", params: a });
    },
    editProcess2(a) {
      this.$router.push({ name: "bagno-procesos-ingreso2", params: a });
    },
    openReport(a) {
      this.process_id = a;
      this.report = "report";
      this.$bvModal.show("modal-process-report");
    },
    jsonToQueryString(json) {
      var result = {};
      for (var key in json) {
        if (json[key] !== "") {
          result[key] = json[key];
        }
      }

      var a = encodeURIComponent(JSON.stringify(result));

      return "/api/v1/stock/?query=" + a;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    getBadge(status) {
      return status === "Abierto" ? "light" : "dark";
    },
    async fetchData() {
      const response = await this.$axios.get(
        this.jsonToQueryString(this.$refs.table.query)
      );
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__columns-dropdown {
    padding-right: 20px;
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
